import React from 'react';

import { twMerge } from 'tailwind-merge';

import type { IconTypes } from 'components-new/icon/icon.types';
import Icon from 'components-new/icon/icon';

interface IconButtonProps {
  icon: IconTypes;
  size?: 'small' | 'medium';
  disabled?: boolean;
  buttonClassName?: string;
  iconClassName?: string;
  onClick?: () => void;
}

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      icon,
      size = 'medium',
      disabled,
      buttonClassName,
      iconClassName,
      onClick,
      ...props
    },
    ref,
  ) => {
    const buttonClassNames = twMerge(
      'transition ease-in-out duration-150',
      'appearance-none text-gray400',
      size === 'medium' && 'p-1 rounded-lg',
      size === 'small' && 'p-[2.5px] rounded',
      !disabled && 'hover:bg-background-hover active:text-gray-500',
      !disabled && 'focus:outline-none focus:bg-background-pressed',
      disabled && 'text-gray200',
      buttonClassName,
    );

    const iconSize = size === 'medium' ? 20 : 15;
    return (
      <button
        type="button"
        ref={ref}
        disabled={disabled}
        className={buttonClassNames}
        onClick={onClick}
        {...props}
      >
        <Icon icon={icon} size={iconSize} className={iconClassName} />
      </button>
    );
  },
);

IconButton.displayName = 'IconButton';

export default IconButton;
